module.exports = __webpack_public_path__ + "img/tx-bar.c1d16a26.png";